<template>
  <div>
    <div class="f-search-block">
      <div class="search-items">
        <div class="field-item">
          <div class="field-item-label">
            标签组/标签：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.title"
              placeholder="请输入标签组/标签"
              class="input-m"
              clearable
            />
          </div>
        </div>
      </div>
      <div class="search-btns">
        <el-button
          type="primary"
          @click="haddleSearch"
        >
          查询
        </el-button>
      </div>
    </div>
    <div class="f-toolbar-block">
      <el-button
        type="primary"
        @click="createLable"
      >
        新建标签组
      </el-button>
      <el-button
        type="primary"
        :loading="syncLoading"
        @click="syncBabel"
      >
        同步企微标签
      </el-button>
    </div>
    <div class="f-table-block">
      <el-table
        v-loading="loading"
        :data="listData"
      >
        <el-table-column
          prop="title"
          label="标签组"
          width="150px"
        >
          <template slot-scope="scope">
            <div>
              <span class="m-r-6">{{ scope.row.title }}</span>
              <el-tooltip
                v-if="scope.row.is_wechat === 1"
                class="tooltip"
                effect="dark"
                content="企业自建"
                placement="top"
              >
                <el-tag size="mini">
                  企
                </el-tag>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="children"
          label="标签"
          width="auto"
        >
          <template slot-scope="scope">
            <SpLabelList
              :readonly="scope.row.is_wechat === 1"
              :label-list="scope.row.children"
              :tags-id="scope.row.id"
            />
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="220px"
        >
          <template
            v-if="scope.row.is_wechat !== 1"
            slot-scope="scope"
          >
            <el-button
              type="text"
              size="small"
              @click="handleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleDel(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="table-pagination"
        background
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 编辑组件 -->
    <SpEditLabel
      v-model="editLabelVisible"
      :label-id="editLabelId"
      @submitLabel="submitLabel"
    />
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataUrl: `${process.env.VUE_APP_BASE_API}/members/member`,
      listData: [],
      params: {
        page: 1,
        page_size: 20,
        title: ''
      },
      total_count: 0,
      loading: false,
      editLabelVisible: false,
      editLabelId: 0,
      editLabelData: {},
      syncLoading: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList () {
      const data = await this.$api.customer.getTagsList(this.params)
      if (data) {
        this.listData = data.list
        this.total_count = data.total_count
      }
    },
    // 创建
    createLable () {
      this.editLabelVisible = true
      this.editLabelId = 0
    },
    // 编辑
    handleEdit (row) {
      this.editLabelVisible = true
      this.editLabelData = row
      this.editLabelId = row.id
    },
    // 删除
    handleDel (row) {
      this.$confirm('此操作将永久删除该标签组，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const data = await this.$api.customer.deleteTags(row.id)
          if (data && data.status) {
            this.$message.success('删除成功')
            this.haddleSearch()
          } else {
            this.$message.error('删除失败')
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 查询
    haddleSearch () {
      this.params.page = 1
      this.getList()
    },
    // 分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },
    // 新建标签
    submitLabel () {
      this.params.page = 1
      this.getList()
      this.editLabelVisible = false
    },

    // 同步企微标签
    async syncBabel () {
      this.syncLoading = true
      const data = await this.$api.customer.syncWechatBabel().catch(() => {
        this.syncLoading = false
      })
      if (data && data.status) {
        this.syncLoading = false
        this.$message.success('同步成功！')
        this.haddleSearch()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip {
  cursor: pointer;
}
</style>
